import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/website/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Fetch";
const frontMatter = {};
import Example from '@/examples/fetch';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  return <Example />;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/examples/fetch',
  {"filePath":"src/pages/examples/fetch.mdx","timestamp":1758556082000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)